export default "/public/dist/img/logoheaderpage.png";